import { FormTemplate } from '../models/FormTemplate';
import { User } from '../models/User';

export const reservedDataSourceKeys = [
  'birthDate',
  'state',
  'biologicalSex',
  'phoneNumber',
  'phoneNumberCode',
  'notifyForMessages',
  'notifyForStudy'
];

/**
 * Check that all required fields have been completed
 * @param formTemplate
 * @param formData
 * @returns
 */
export function hasCompletedFormTemplateFields(
  formTemplate: FormTemplate,
  formData: any,
  user?: User | null
) {
  for (const stateNode of formTemplate.config?.states || []) {
    const elements = stateNode.meta?.elements || [];
    for (const element of elements) {
      if (
        element.required &&
        element.dataSource &&
        (typeof formData[element.dataSource] === 'undefined' ||
          formData[element.dataSource] === null) &&
        (reservedDataSourceKeys.includes(element.dataSource)
          ? !user?.[element.dataSource as keyof User]
          : false)
      ) {
        return false;
      }
    }
  }
  return true;
}
